import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-user\"><title>资源 1</title><g id=\"icon-user_图层_2\" data-name=\"图层 2\"><g id=\"icon-user_图层_1-2\" data-name=\"图层 1\"><path d=\"M596.05,518.87C703.82,485.06,782,384.42,782,265.5,782,118.87,663.13,0,516.5,0S251,118.87,251,265.5c0,117.82,76.75,217.7,183,252.41C188.24,555.48,0,767.76,0,1024H1024C1024,769.86,838.83,559,596.05,518.87Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user.svg
// module id = VdD3
// module chunks = 54